
export default {
  code: "nl",
  week: {
    dow: 1, // Monday is the first day of the week.
    doy: 4  // The week that contains Jan 4th is the first week of the year.
  },
  buttonText: {
    prev: "Voorgaand",
    next: "Volgende",
    today: "Vandaag",
    year: "Jaar",
    month: "Maand",
    week: "Week",
    day: "Dag",
    list: "Agenda"
  },
  allDayText: "Hele dag",
  eventLimitText: "extra",
  noEventsMessage: "Geen evenementen om te laten zien"
};
